// Single source of truth for external CTA URLs used across pricing,
// readiness, and build/welcome pages. Swap these values when real
// HubSpot + Stripe links are ready — every CTA imports from here.

export const HUBSPOT_800_SESSION = 'https://www.roofingbusinesspartner.com/meetings/adamsandlinks/roofclaw-ai-readiness';
export const STRIPE_10K = 'https://buy.stripe.com/4gM6oG1SQfKz5PmegX2kw09';
export const STRIPE_9200 = 'https://buy.stripe.com/4gM28q9li41Ra5Cc8P2kw0a';
